import { Button, useModal } from "@newsela/angelou";
import {
  actionNames,
  actionPrefixes,
  objectTypes,
  withTrackEvent,
} from "@newsela/snitch";
import PropTypes from "prop-types";

import getEventPropertiesContentType from "@/view/utils/getEventPropertiesContentType";
import ContentDisplayDetailsRow from "../ContentDisplayDetailsRow";
import StandardsModal from "./StandardsModal";
import { standardsCss, standardsButtonCss } from "./StandardsRow.style";

const ButtonWithTrackEvent = withTrackEvent(Button);

const propTypes = {
  contentMetadata: PropTypes.array,
  content: PropTypes.object,
};

const StandardsRow = ({ contentMetadata, content }) => {
  const [modalProps, setActive, triggerRef] = useModal(false);

  const standards = contentMetadata?.filter(
    (datum) => datum.content_type === "STANDARD",
  );

  if (standards?.length === 0) return null;

  const standardsLabel = `Standards (${standards?.length})`;

  const getStandardsValue = () => {
    const standardNames = standards?.map((standard) => standard.data.name);
    const isTruncatedList = standardNames?.length > 3;

    return (
      <>
        <span css={standardsCss}>
          {standardNames?.slice(0, 3).join(", ")}
          {isTruncatedList ? "..." : ""}
        </span>
        <ButtonWithTrackEvent
          __cssFor={{ root: standardsButtonCss }}
          flavor={Button.flavors.tertiary}
          size={Button.sizes.md}
          onClick={() => setActive(true)}
          ref={triggerRef}
          objectType={objectTypes.content}
          actionName={actionNames.interact}
          actionPrefix={actionPrefixes.initiate}
          streamProperties={{
            description: "Show standards modal on view page",
            content_id: content?.id,
            content_type: getEventPropertiesContentType(content?.content_type),
          }}
        >
          {isTruncatedList ? "View all" : "View details"}
        </ButtonWithTrackEvent>
      </>
    );
  };

  const standardsRowData = [
    { label: standardsLabel, value: getStandardsValue() },
  ];

  return (
    <>
      <ContentDisplayDetailsRow row={standardsRowData} key="standards" />
      <StandardsModal
        standards={standards}
        standardsLabel={standardsLabel}
        setActive={setActive}
        modalProps={modalProps}
      />
    </>
  );
};

StandardsRow.propTypes = propTypes;

export default StandardsRow;
